import { Inject, Injectable } from '@angular/core';
import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  GetManyV2Dto,
  PageableListV2Dto,
  ResponseDto,
} from '@fleet-beat/core';
import { catchError, map, Observable } from 'rxjs';

import { HttpErrorResponse } from '@angular/common/http';
import { DvirDto, FmcsaReportsDto } from '@fleet-beat/api';
import { DotInspectionDaysDto } from '../../models/fmcsa-reports/dot-inspection-days.dto';

@Injectable({
  providedIn: 'root',
})
export class FmcsaReportsApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}/fmcsa-reports`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  getManyV2(data: GetManyV2Dto, auth: AuthHeaders): Observable<PageableListV2Dto<FmcsaReportsDto>> {
    return this.baseApiService.get(this.baseUrl, { auth, params: data }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<FmcsaReportsDto[]>) => this.baseApiService.mapResponseV2(response)),
      map((response: ResponseDto<FmcsaReportsDto[]>) => {
        return {
          data: response.data,
          ...response.meta,
        };
      }),
    );
  }
  getByDriver(
    driverId: string,
    dateRange: string,
    auth: AuthHeaders,
  ): Observable<PageableListV2Dto<DotInspectionDaysDto>> {
    return this.baseApiService.get(`${this.baseUrl}/${driverId}/by-driver/${dateRange}`, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<DotInspectionDaysDto[]>) => this.baseApiService.mapResponseV2(response)),
      map((response: ResponseDto<DotInspectionDaysDto[]>) => {
        return {
          data: response.data,
          ...response.meta,
        };
      }),
    );
  }
}
